import { css } from "@emotion/css";
import { type Properties } from "signlets";

import logo from "../logo.svg";
import { Button } from "./Button";
import { H1 } from "./H1";
import { NewIcon } from "./icons/NewIcon";
import { UploadIcon } from "./icons/UploadIcon";
import { Modal } from "./Modal";

const style = css`
  width: 26rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;

  > .buttons {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
  }
`;

export type IntroductionProps = {
  visible: boolean;
  onNew: () => void;
  onLoad: () => void;
};

export const Introduction = ({
  visible,
  onNew,
  onLoad,
}: Properties<IntroductionProps>) => (
  <Modal visible={visible} class={style}>
    <img class="logo" src={logo} alt="Logo" />
    <H1>GD-2000 Mission Planner</H1>
    <div class="buttons">
      <Button onClick={onNew}>
        <NewIcon />
        New mission
      </Button>
      <Button onClick={onLoad}>
        <UploadIcon />
        Load mission...
      </Button>
    </div>
  </Modal>
);
